import React from "react";
import RenderCheckboxInEvents from "./eventItem/CheckboxesinEvents";
import RenderCustomEvent from "./eventItem/CustomEvents";
import RenderStandardEvent from "./eventItem/StandardEvents";
import RenderButtonsInEvents from "./eventItem/ButtonsinEvents";

// Functional component to render an event item from props
const Eventitem = (props) => {
  // Ensure container is a string to safely call .includes
  const container = props.container || "";

  return (
    <React.Fragment key={props.id}>
      {props.type && (props.type === "custom" || props.type === "reservation") ? (
        <RenderCustomEvent {...props}>
          {container.includes("events") && <RenderCheckboxInEvents {...props} />}
        </RenderCustomEvent>
      ) : (
        <RenderStandardEvent {...props}>
          {container.includes("events") && <RenderCheckboxInEvents {...props} />}
        </RenderStandardEvent>
      )}

      {container.includes("events") && (
        <RenderButtonsInEvents {...props} />
      )}
    </React.Fragment>
  );
};

export default Eventitem;
